import { FC, SVGProps } from 'react'
import { ReactComponent as ChatGPTIcon } from 'src/assets/svg/ai-tools/chatgpt.svg'
import { ReactComponent as ClaudeIcon } from 'src/assets/svg/ai-tools/claude.svg'
import { ReactComponent as GeminiIcon } from 'src/assets/svg/ai-tools/gemini.svg'
import { ReactComponent as PerplexityIcon } from 'src/assets/svg/ai-tools/perplexity.svg'

type SvgIcon = FC<SVGProps<SVGSVGElement>>

// The one map of AI model logos. Keyed by the display name the API uses
// ("ChatGPT", "Perplexity", …).
export const AI_TOOL_ICONS: Record<string, SvgIcon> = {
  ChatGPT: ChatGPTIcon,
  Claude: ClaudeIcon,
  Gemini: GeminiIcon,
  Perplexity: PerplexityIcon,
}

const ICONS_BY_LOWERCASE_NAME: Record<string, SvgIcon> = Object.fromEntries(
  Object.entries(AI_TOOL_ICONS).map(([name, icon]) => [
    name.toLowerCase(),
    icon,
  ])
)

// Some payloads (smart-insight sources) spell the model in lower case.
export const getAiToolIcon = (name?: string | null): SvgIcon | undefined =>
  name ? ICONS_BY_LOWERCASE_NAME[name.toLowerCase()] : undefined

interface AiToolIconProps {
  className?: string
  name?: string | null
}

export const AiToolIcon: FC<AiToolIconProps> = ({ className, name }) => {
  const Icon = getAiToolIcon(name)
  return Icon ? <Icon className={className} /> : null
}
